import script from "./Knowledge.vue?vue&type=script&setup=true&lang=js"
export * from "./Knowledge.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__